import styled from 'styled-components';
import { mq } from '~/styles/grid';

const height = 2;
const heightMdUp = 1;

const Wrapper = styled.div`
  border-bottom: ${height}px solid ${(props) => props.theme.color.gray500};

  &:first-of-type {
    border-top: ${height}px solid ${(props) => props.theme.color.gray500};
  }

  @media (${mq.mdUp}) {
    border-bottom: ${heightMdUp}px solid ${(props) => props.theme.color.gray400};

    &:first-of-type {
      border-top: ${heightMdUp}px solid ${(props) => props.theme.color.gray400};
    }
  }
`;

const Description = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 35px 20px 35px 10px;
  font-size: 20px;
  line-height: 1.5;
  color: ${(props) => props.theme.color.primary800};
  transition: color 0.25s ease-out;

  @media (${mq.mdUp}) {
    padding: 25px 35px;
  }

  span {
    padding-right: 25px;
  }
`;

const padding = 5;

const Content = styled.div`
  margin-top: ${(props) => (props.isOpen ? '0' : `-${padding}px`)};
  opacity: ${(props) => (props.isOpen ? '1' : '0')};
  height: ${(props) => (props.isOpen ? 'auto' : '0')};
  overflow: ${(props) => (props.isOpen ? 'auto' : 'hidden')};
  padding: ${(props) => (props.isOpen ? '20px' : '0')} 10px
    ${(props) => (props.isOpen ? '30px' : `${padding}px`)};
  transition:
    margin-top 0.25s ease-out,
    opacity 0.25s ease-out,
    padding-bottom 0.25s ease-out;

  @media (${mq.mdUp}) {
    padding: ${(props) => (props.isOpen ? '20px' : '0')} 35px
      ${(props) => (props.isOpen ? '30px' : `${padding}px`)};
  }
`;
const Bar = styled.div`
  height: 2px;
  background-color: ${(props) => props.theme.color.primary800};
  width: 17px;
  min-width: 17px;
`;

const Bars = styled.div`
  position: relative;
  top: 14px;
  height: 100%;
  /* stylelint-disable */
  ${Bar}:last-of-type {
    transform: rotate(90deg);
    transform-origin: center;
    margin-top: -2px;
    background: ${(props) =>
      props.isOpen ? 'transparent' : props.theme.color.primary800};
  }
  /* stylelint-enable */
`;

/**
 * @param {AccordionItemProps} props
 * @returns {React.ReactElement} The rendered component
 */
const AccordionItem = ({ description, isOpen = false, children, clicked }) => {
  const handleDescriptionClick = () => {
    clicked();
  };

  return (
    <Wrapper>
      <Description role="button" onClick={handleDescriptionClick}>
        <span>{description}</span>
        <Bars isOpen={isOpen}>
          <Bar className="accordionItemBar" />
          <Bar className="accordionItemBar" />
        </Bars>
      </Description>
      <Content isOpen={isOpen}>{children}</Content>
    </Wrapper>
  );
};

export default AccordionItem;
